import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../wayfinder'
/**
* @see routes/web.php:57
* @route '/'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:57
* @route '/'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see routes/web.php:57
* @route '/'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see routes/web.php:57
* @route '/'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ContactController::contact
* @see app/Http/Controllers/ContactController.php:19
* @route '/kontakt'
*/
export const contact = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

contact.definition = {
    methods: ["get","head"],
    url: '/kontakt',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ContactController::contact
* @see app/Http/Controllers/ContactController.php:19
* @route '/kontakt'
*/
contact.url = (options?: RouteQueryOptions) => {
    return contact.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ContactController::contact
* @see app/Http/Controllers/ContactController.php:19
* @route '/kontakt'
*/
contact.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: contact.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ContactController::contact
* @see app/Http/Controllers/ContactController.php:19
* @route '/kontakt'
*/
contact.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: contact.url(options),
    method: 'head',
})

/**
* @see routes/web.php:153
* @route '/reference'
*/
export const references = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: references.url(options),
    method: 'get',
})

references.definition = {
    methods: ["get","head"],
    url: '/reference',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:153
* @route '/reference'
*/
references.url = (options?: RouteQueryOptions) => {
    return references.definition.url + queryParams(options)
}

/**
* @see routes/web.php:153
* @route '/reference'
*/
references.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: references.url(options),
    method: 'get',
})

/**
* @see routes/web.php:153
* @route '/reference'
*/
references.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: references.url(options),
    method: 'head',
})

/**
* @see routes/web.php:158
* @route '/gdpr'
*/
export const gdpr = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: gdpr.url(options),
    method: 'get',
})

gdpr.definition = {
    methods: ["get","head"],
    url: '/gdpr',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:158
* @route '/gdpr'
*/
gdpr.url = (options?: RouteQueryOptions) => {
    return gdpr.definition.url + queryParams(options)
}

/**
* @see routes/web.php:158
* @route '/gdpr'
*/
gdpr.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: gdpr.url(options),
    method: 'get',
})

/**
* @see routes/web.php:158
* @route '/gdpr'
*/
gdpr.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: gdpr.url(options),
    method: 'head',
})

/**
* @see routes/web.php:162
* @route '/obchodni-podminky'
*/
export const terms = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: terms.url(options),
    method: 'get',
})

terms.definition = {
    methods: ["get","head"],
    url: '/obchodni-podminky',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:162
* @route '/obchodni-podminky'
*/
terms.url = (options?: RouteQueryOptions) => {
    return terms.definition.url + queryParams(options)
}

/**
* @see routes/web.php:162
* @route '/obchodni-podminky'
*/
terms.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: terms.url(options),
    method: 'get',
})

/**
* @see routes/web.php:162
* @route '/obchodni-podminky'
*/
terms.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: terms.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\LocalLandingController::localLanding
* @see app/Http/Controllers/LocalLandingController.php:146
* @route '/pronajem-bagru/{region}/{district}/{city}'
*/
export const localLanding = (args: { region: string | number, district: string | number, city: string | number } | [region: string | number, district: string | number, city: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: localLanding.url(args, options),
    method: 'get',
})

localLanding.definition = {
    methods: ["get","head"],
    url: '/pronajem-bagru/{region}/{district}/{city}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\LocalLandingController::localLanding
* @see app/Http/Controllers/LocalLandingController.php:146
* @route '/pronajem-bagru/{region}/{district}/{city}'
*/
localLanding.url = (args: { region: string | number, district: string | number, city: string | number } | [region: string | number, district: string | number, city: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            region: args[0],
            district: args[1],
            city: args[2],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        region: args.region,
        district: args.district,
        city: args.city,
    }

    return localLanding.definition.url
            .replace('{region}', parsedArgs.region.toString())
            .replace('{district}', parsedArgs.district.toString())
            .replace('{city}', parsedArgs.city.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\LocalLandingController::localLanding
* @see app/Http/Controllers/LocalLandingController.php:146
* @route '/pronajem-bagru/{region}/{district}/{city}'
*/
localLanding.get = (args: { region: string | number, district: string | number, city: string | number } | [region: string | number, district: string | number, city: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: localLanding.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\LocalLandingController::localLanding
* @see app/Http/Controllers/LocalLandingController.php:146
* @route '/pronajem-bagru/{region}/{district}/{city}'
*/
localLanding.head = (args: { region: string | number, district: string | number, city: string | number } | [region: string | number, district: string | number, city: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: localLanding.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:23
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:23
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:23
* @route '/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:23
* @route '/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:95
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:95
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:95
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

